
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrowRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.501 4.501a.763.763 0 0 1 .416.116l.117.09 6.755 6.754a.763.763 0 0 1 0 1.078l-6.75 6.75-.005.005a.763.763 0 0 1-1.078-1.078l.005-.005 5.448-5.449H3.75a.762.762 0 1 1 0-1.524h14.66l-5.45-5.45-.004-.004a.762.762 0 0 1 .545-1.283Z",
  fill: "#810EA9",
  stroke: "#810EA9",
  strokeWidth: 0.4
})));

      const __svgRaw = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n<path d=\"M13.501 4.50134C13.6488 4.49881 13.7932 4.53952 13.917 4.61658L14.0342 4.70642L20.7891 11.4613C20.9318 11.6043 21.0117 11.7983 21.0117 12.0004C21.0116 12.2022 20.9316 12.3956 20.7891 12.5385L14.0391 19.2885L14.0342 19.2943C13.8897 19.4289 13.6983 19.5018 13.501 19.4984C13.3034 19.4949 13.1143 19.4145 12.9746 19.2748C12.8351 19.1351 12.7554 18.9468 12.752 18.7494C12.7485 18.5519 12.8214 18.3607 12.9561 18.2162L12.9609 18.2113L18.4092 12.7621H3.75C3.54786 12.7621 3.35392 12.6823 3.21094 12.5394C3.06803 12.3965 2.9874 12.2025 2.9873 12.0004C2.9873 11.7982 3.06805 11.6043 3.21094 11.4613C3.35393 11.3183 3.54777 11.2377 3.75 11.2377H18.4092L12.9609 5.78845L12.9561 5.78357C12.8215 5.63905 12.7485 5.44781 12.752 5.25037C12.7555 5.05299 12.8351 4.86461 12.9746 4.72498C13.1143 4.58527 13.3034 4.50483 13.501 4.50134Z\" fill=\"#810EA9\" stroke=\"#810EA9\" stroke-width=\"0.4\"/>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/arrow-right.f3e10660f6e931f0dcb4f51a398c854f.svg"),
        {
          React: SvgArrowRight,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      